var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrcode"},[_c('div',{staticClass:"qr-container"},[_c('div',{staticClass:"qrbg"},[_c('van-image',{staticClass:"qrcode",attrs:{"src":_vm.codeImg}})],1),_c('p',{staticClass:"desc"},[_vm._v("请扫一扫资产二维码")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }